// extracted by mini-css-extract-plugin
export var active = "side-menu-module--active--jyYm6";
export var blur = "side-menu-module--blur--mBlvR";
export var cssAnimation = "side-menu-module--cssAnimation--PWDHr";
export var sideMenu = "side-menu-module--sideMenu--kRL5p";
export var sideNav = "side-menu-module--sideNav--0Ejy4";